<div class="page has-breadcrumb has-title">
  <h1>{{ title }}</h1>
  <small>
    {{
      "Feedback received by this user in the marketplace. Please be kind and respectful in your comments." | translate
    }}
  </small>

  <div *ngIf="feedback !== undefined; else loadingTemplate" class="feedback-list">
    <p *ngIf="feedback.count === 0">
      {{ "This user has no marketplace feedback yet." | translate }}
    </p>

    <ng-container *ngIf="feedback.count > 0">
      <div *ngFor="let feedbackItem of feedback.results" class="feedback-container">
        <astrobin-marketplace-feedback [feedback]="feedbackItem"></astrobin-marketplace-feedback>
      </div>
    </ng-container>
  </div>

  <ngb-pagination
    *ngIf="feedback && feedback.count > feedback.results.length"
    [boundaryLinks]="true"
    [collectionSize]="feedback.count"
    [directionLinks]="true"
    [ellipses]="true"
    [maxSize]="5"
    [page]="page"
    [rotate]="true"
    (pageChange)="loadFeedback($event)"
  >
    <ng-template ngbPaginationPrevious>&larr;</ng-template>
    <ng-template ngbPaginationNext>&rarr;</ng-template>
  </ngb-pagination>
</div>

<ng-template #loadingTemplate>
  <astrobin-loading-indicator></astrobin-loading-indicator>
</ng-template>
